import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createWrapper } from 'next-redux-wrapper';
import rootSaga from '~/sagas';
import createReducer from '~/reducers';

let store;

const bindMiddlewares = (middlewares) => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension');
    return composeWithDevTools(applyMiddleware(...middlewares));
  }
  return applyMiddleware(...middlewares);
};

// const sagaMiddleware = createSagaMiddleware();

export const makeStore = () => {
  // * You must create sagaMiddleware inside makeStore function
  // https://github.com/kirill-konshin/next-redux-wrapper/issues/449#issuecomment-1048000623
  const sagaMiddleware = createSagaMiddleware();

  const newStore = createStore(
    createReducer(),
    bindMiddlewares([sagaMiddleware]),
  );

  newStore.runSaga = sagaMiddleware.run;
  newStore.runSagaTask = () => {
    newStore.sagaTask = sagaMiddleware.run(rootSaga);
  };
  newStore.injectedReducers = {}; // Reducer registry
  newStore.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      newStore.replaceReducer(createReducer(newStore.injectedReducers));
    });
  }

  newStore.runSagaTask();

  store = newStore;
  return newStore;
};

export const getStore = () => store;

export const wrapper = createWrapper(makeStore, { debug: false });
